// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__GBQGr","title":"Header_title__3bA6F","brokerInfoCard":"Header_brokerInfoCard__1hb1a"};